import { Component, Input, EventEmitter } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { ModalAction } from '../models';
import { SendMessageService } from './send-message.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { handleErrors } from '../common/error';
import { emptySpaceValidator } from '../validators/emptySpaceValidator';

@Component({
  selector: 'send-message',
  templateUrl: './send-message.component.html',
  styleUrls: ['./send-message.component.css'],
  providers: [],
})
export class SendMessageComponent {
  sendMessageForm: UntypedFormGroup;
  subjectField: UntypedFormControl;
  messageTextField: UntypedFormControl;

  @Input() modalActions: EventEmitter<string | ModalAction>;

  isSendingMessage = false;

  constructor(
    private messageService: SendMessageService,
    private builder: UntypedFormBuilder,
    private translateService: TranslateService,
    private toastr: ToastrService
  ) {
    this.subjectField = new UntypedFormControl('', [Validators.required, emptySpaceValidator()]);
    this.messageTextField = new UntypedFormControl('', [Validators.required, emptySpaceValidator()]);

    this.sendMessageForm = builder.group({
      subjectField: this.subjectField,
      messageTextField: this.messageTextField,
    });
  }

  onSubmit() {
        /* prevent sending duplicated email by repeated click before message is sent */
    if (this.isSendingMessage) {
      return;
    }

    this.isSendingMessage = true;
    this.messageService.submitMessage(this.subjectField.value, this.messageTextField.value).subscribe(
      (response) => {
        this.toastr.success(
          this.translateService.instant('SendMessageComponent-TOAST_SUCCESS', { text: this.subjectField.value }),
          this.translateService.instant('SendMessageComponent-TITLE'),
          { timeOut: 5000 }
        );

        this.isSendingMessage = false;
        this.resetMessageForm();
        this.modalActions.emit({ action: 'modal', params: ['close'] });
      },
      (error) => {
        handleErrors(error, this.translateService, this.toastr, 'SendMessageComponent-TITLE');

        this.isSendingMessage = false;
        this.modalActions.emit({ action: 'modal', params: ['close'] });
      }
    );
  }

  private resetMessageForm() {
    // reset the form values on successful submit
    this.subjectField = new UntypedFormControl('', Validators.required);
    this.messageTextField = new UntypedFormControl('', Validators.required);

    this.sendMessageForm = this.builder.group({
      subjectField: this.subjectField,
      messageTextField: this.messageTextField,
    });
  }

  onCancel() {
    this.modalActions.emit({ action: 'modal', params: ['close'] });
    this.resetMessageForm();
  }
}
